import { render } from "./ScoreInfoArea.vue?vue&type=template&id=34e7533c&scoped=true"
import script from "./ScoreInfoArea.vue?vue&type=script&lang=js"
export * from "./ScoreInfoArea.vue?vue&type=script&lang=js"

import "./ScoreInfoArea.vue?vue&type=style&index=0&id=34e7533c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e7533c"]])

export default __exports__